import { EventContentArg } from '@fullcalendar/react';
import * as React from 'react';
import * as moment from 'moment';

function MonthView (eventInfo: EventContentArg) {
    const { event } = eventInfo;
    const { extendedProps, title, allDay, end, start } = event || {};
    const { time, categories, moreInfo, location, eventTitle, eventCategoryColor } = extendedProps || {};
            
    return (<>
        <div className="short-event-text">

            <p>{title}</p>
            <label>{categories}</label>
            <div className="short-text-box">
                <a href={moreInfo}><span>{time} </span></a>
            </div>
            

        </div>
    </>);
}

export default MonthView;